export default __webpack_public_path__ + "static/media/circle.ec1038c8.webp";